/**
 * @generated SignedSource<<22048c770a3c81c2e51c56fe19d76db3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetFlexiUnitPodcastLabelPodcast$data = {
  readonly __typename: "Podcast";
  readonly " $fragmentType": "helpersGetFlexiUnitPodcastLabelPodcast";
};
export type helpersGetFlexiUnitPodcastLabelPodcast$key = {
  readonly " $data"?: helpersGetFlexiUnitPodcastLabelPodcast$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetFlexiUnitPodcastLabelPodcast">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetFlexiUnitPodcastLabelPodcast"
};

(node as any).hash = "d4ed093b9abfde10ea9b9e5400af3304";

export default node;
